import React, { useState, useEffect, useRef } from 'react';
import { useLang } from '../context/LanguageContext';
import './LanguagePicker.css';

// SVG inline — les emojis régionaux ne sont pas rendus comme drapeaux sur Windows.
const FlagFR = () => (
  <svg viewBox="0 0 3 2" className="lang-flag-svg" aria-hidden="true">
    <rect width="1" height="2" x="0" fill="#0055A4" />
    <rect width="1" height="2" x="1" fill="#FFFFFF" />
    <rect width="1" height="2" x="2" fill="#EF4135" />
  </svg>
);

const FlagDE = () => (
  <svg viewBox="0 0 5 3" className="lang-flag-svg" aria-hidden="true">
    <rect width="5" height="1" y="0" fill="#000000" />
    <rect width="5" height="1" y="1" fill="#DD0000" />
    <rect width="5" height="1" y="2" fill="#FFCE00" />
  </svg>
);

const FLAGS = { fr: FlagFR, de: FlagDE };

const LABELS = {
  fr: 'FR',
  de: 'DE',
};

export default function LanguagePicker() {
  const { lang, setLang, supported } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="lang-picker" ref={ref}>
      <button
        type="button"
        className="lang-picker-btn"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Changer la langue / Sprache wechseln"
      >
        <span className="lang-flag" aria-hidden="true">{(() => { const F = FLAGS[lang]; return F ? <F /> : null; })()}</span>
        <span className="lang-code">{LABELS[lang]}</span>
        <i className={`fa-solid fa-chevron-down lang-chevron ${open ? 'open' : ''}`} />
      </button>

      {open && (
        <ul className="lang-dropdown" role="listbox">
          {supported.map(code => (
            <li key={code}>
              <button
                type="button"
                role="option"
                aria-selected={lang === code}
                className={`lang-option ${lang === code ? 'active' : ''}`}
                onClick={() => { setLang(code); setOpen(false); }}
              >
                <span className="lang-flag" aria-hidden="true">{(() => { const F = FLAGS[code]; return F ? <F /> : null; })()}</span>
                <span>{LABELS[code]}</span>
                {lang === code && <i className="fa-solid fa-check lang-check" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
